if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (document.querySelector('body').classList.contains('one-time')) {
        document.querySelector('body').classList.remove('one-time')
      }

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    async show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      let productID = opener.getAttribute('data-product-id');
    
      try {
        const response = await fetch(opener.getAttribute('data-product-url'));
        const responseText = await response.text();
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
        this.preventDuplicatedIDs();
        this.removeDOMElements();
        this.setInnerHTML(this.modalContent, this.productElement.innerHTML, productID);

        let sellingPrice = '',
            oneTimePrice = '';
    
        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
    
        if (window.ProductModel) window.ProductModel.loadShopifyXR();
    
        this.removeGalleryListSemantic();
        this.updateImageSizes();
        this.preventVariantURLSwitching();
        super.show(opener);
    
        document.querySelectorAll('[name="custom_id"]').forEach(element => {
          element.addEventListener('change', evt => {
            document.querySelector(`variant-radios input[value="${evt.currentTarget.value}"]`).click();

            sellingPrice = evt.currentTarget.getAttribute('data-selling-price');
            oneTimePrice = evt.currentTarget.getAttribute('data-price');

            document.querySelector(`#QuickAdd-${productID} .rc_widget__option__label[data-label-subsave] .rc_widget__price--subsave`).textContent = sellingPrice;
            document.querySelector(`#QuickAdd-${productID} .rc_widget__option__label[data-label-onetime] .rc_widget__price--onetime`).textContent = oneTimePrice;

          });
        });

        window.ReChargeWidget.createWidget({ productId: parseInt(productID), injectionParent: `#QuickAdd-${productID} form[action*="cart/add"]` });
        

      } catch (error) {
        // Handle any errors that occurred during the fetch or parsing
        console.error(error);
      } finally {
        opener.removeAttribute('aria-disabled');
        opener.classList.remove('loading');
        opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        try {
          this.changeFrequency(productID);
        } catch (error) {
          console.log(error);
        }
      }
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    changeFrequency( productID ) {

      // Get the parent element where the observation is to be made
      const parentElement = document.querySelector(`#QuickAdd-${productID} form[action*="cart/add"]`);

      // Configure observer options
      const observerOptions = {
        childList: true,
        subtree: true 
      };

      // Create an instance of MutationObserver with a handling function
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            for (const addedNode of mutation.addedNodes) {
              // Check if the added node is an object
              if (addedNode instanceof Object) {
                let selectOptions = document.querySelector(`#QuickAddInfo-${productID} select[name="custom_selling_plan"]`),
                selectOptionsRecharge = document.querySelector(`#QuickAddInfo-${productID} select.rc_widget__option__plans__dropdown`),
                value = '';
                // Listen to the 'change' event in the main select
                selectOptions.addEventListener('change', (e) => {
                  value = e.target.value;
                  // Set the value in the ReCharge select and dispatch the 'change' event
                  selectOptionsRecharge.value = value;
                  selectOptionsRecharge.dispatchEvent(new Event('change'));
                  observer.disconnect();
                })

                document.querySelector('.rc-container-wrapper .rc-template__legacy-radio').addEventListener('change', evt=>{

                  document.querySelectorAll('.quantity-option input').forEach(input => {
                    if (input.checked) {
                      document.querySelector(`.rc_widget__option__label[data-label-subsave] .rc_widget__price--subsave`).textContent = input.getAttribute('data-selling-price');;
                      document.querySelector(`.rc_widget__option__label[data-label-onetime] .rc_widget__price--onetime`).textContent = input.getAttribute('data-price');
                    }
                  });

                  if(evt.target.classList.contains('rc_widget__option__input--onetime')){
                    document.querySelector('body').classList.add('one-time');
                    evt.stopImmediatePropagation()
                  }else {
                    if (document.querySelector('body').classList.contains('one-time')) {
                      document.querySelector('body').classList.remove('one-time');
                      evt.stopImmediatePropagation()
                    }
                  }
                })

              }
            }
          }
        }
      });

      observer.observe(parentElement, observerOptions);

    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
